import { useMutation, useQueryClient } from '@tanstack/react-query';
import { buildPartnerGroupChannelUpdatePayload } from '../components/Partner/Community/communityEditConstants';
import { updatePartnerGroupChannel } from '../services/partnerGroupChannel';
import { partnerGroupChannelQueryKeys } from './use-partner-group-channel-query';

export const useUpdatePartnerGroupChannelMutation = (options = {}) => {
  const queryClient = useQueryClient();
  const { onSuccess, onError, ...restOptions } = options;

  return useMutation({
    mutationFn: async ({ form }) => {
      const payload = buildPartnerGroupChannelUpdatePayload(form);
      const result = await updatePartnerGroupChannel(payload);

      if (!result.success) {
        throw new Error(result.message || 'Failed to update community channel');
      }

      return result;
    },
    onSuccess: async (data, variables, context) => {
      await queryClient.invalidateQueries({ queryKey: partnerGroupChannelQueryKeys.detail() });
      await onSuccess?.(data, variables, context);
    },
    onError: (error, variables, context) => {
      onError?.(error, variables, context);
    },
    ...restOptions,
  });
};
